import React from 'react';
import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapPin } from '@fortawesome/pro-light-svg-icons';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';

const ResultContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${SPACERS.tiny};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  font-size: 16px;
`;

interface SearchResultProps {
  className?: string;
  location?: string;
}

const SearchResult: React.FC<SearchResultProps> = ({
  className,
  location,
  children,
}) => {
  return (
    <StyledDiv>
      <ResultContent>
        <IconContainer>
          <FontAwesomeIcon icon={faMapPin} />
        </IconContainer>
        <TrueImpactText variant="body">{location}</TrueImpactText>
      </ResultContent>
      <TrueImpactButton variant="secondary-small">Add</TrueImpactButton>
    </StyledDiv>
  );
};

export default SearchResult;
